import type { ApolloError } from '@apollo/client';

import { getSafeApolloErrorMessage } from '@/lib/auth/sessionErrors';

export function extractGraphQLError(error?: ApolloError | null): string | undefined {
  if (!error) return undefined;

  const safeMessage = getSafeApolloErrorMessage(error);

  if (safeMessage) {
    return safeMessage;
  }

  if (error.graphQLErrors?.length) {
    const gqlError = error.graphQLErrors[0];
    const message = gqlError?.message || 'Unexpected error';
    const cause = gqlError?.extensions?.cause;

    return cause ? `${message}: ${cause}` : message;
  }

  if (error.networkError) {
    const netErr = error.networkError as any;
    const innerError = netErr?.result?.errors?.[0];
    const message = innerError?.message || netErr?.message || 'Unexpected server error';
    const cause = innerError?.extensions?.cause;

    return cause ? `${message}: ${cause}` : message;
  }

  return undefined;
}
